import { render } from "./CreateChallenge.vue?vue&type=template&id=be524676"
import script from "./CreateChallenge.vue?vue&type=script&lang=js"
export * from "./CreateChallenge.vue?vue&type=script&lang=js"
script.render = render

export default script